import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private endpoint = 'Client';

  // Prefetch: armazena a promise da chamada iniciada durante o login
  private _prefetchPromise: Promise<any> | null = null;
  private _prefetchHash: string = '';

  constructor(private httpService: HttpService) { }

  /**
   * Inicia o prefetch do Client/graph durante o login (antes do dashboard carregar)
   * Isso economiza ~5s eliminando o tempo de espera entre login e primeira chamada
   */
  prefetch(data: any): void {
    this._prefetchHash = JSON.stringify({
      accounts: (data.accountIds || []).sort(),
      networks: (data.networks || []).sort(),
      start: data.startDate,
      end: data.endDate
    });
    this._prefetchPromise = this.httpService.post(
      `${environment.arboUrl}/${this.endpoint}/graph`, data
    ).catch(err => {
      this._prefetchPromise = null;
      this._prefetchHash = '';
      throw err;
    });
  }

  /**
   * Retorna dados do graph, reutilizando o prefetch se disponível
   */
  getDashboardGraph(data: any): Promise<any> {
    // Verifica se há um prefetch em andamento com os mesmos parâmetros
    const requestHash = JSON.stringify({
      accounts: (data.accountIds || []).sort(),
      networks: (data.networks || []).sort(),
      start: data.startDate,
      end: data.endDate
    });

    if (this._prefetchPromise && this._prefetchHash === requestHash) {
      const promise = this._prefetchPromise;
      this._prefetchPromise = null;
      this._prefetchHash = '';
      return promise;
    }

    // Limpa prefetch antigo se os parâmetros mudaram
    this._prefetchPromise = null;
    this._prefetchHash = '';

    return this.httpService.post(`${environment.arboUrl}/${this.endpoint}/graph`, data);
  }

  /**
   * Limpa o prefetch (ex: ao trocar de organização)
   */
  clearPrefetch(): void {
    this._prefetchPromise = null;
    this._prefetchHash = '';
  }
}
